import { DateRange } from 'rsuite/esm/DateRangePicker';
import { LabelValueType } from '../../components/AsyncFormSelect/AsyncFormSelect';

export enum EVENT_TYPES {
  PREMATCH = 2,
  INPLAY = 3,
}

export enum EVENT_SUB_TYPE {
  EVENT = 1,
  OUTRIGHT = 2,
}

export enum OUTCOME_TYPE {
  NONE = 0,
  HOME = 1,
  DRAW = 2,
  AWAY = 3,
}

export interface SportEvent {
  Team1Id: number;
  Team1Name: string;
  Team2Id: number;
  Team2Name: string;
  StartDate: string;
  StartDateUtc: string;
  CreatedDate: string;
  CreatedDateUtc: string;
  EndDate: string;
  EndDateUtc: string;
  StatusType: number;
  SportId: number;
  CountryId: number;
  TournamentId: number;
  SportName: string;
  CountryName: string;
  TournamentName: string;
  EventType: number;
  EventSubType: number;
  Id: number;
  HasStream: boolean;
  MainResult: string;
  HasEventComments: boolean;
  HasTournamentComments: boolean;
  Turnover: number;
  BetsCount: number;
  ProviderId: number;
  ProviderName: string;
  Mbl: number;
  UniqueFranchise: number;
  UniqueFranchiseName: null | string;
  MaxAmountEvent: number;
  ManagerName: string;
  ManagerUuid: number;
  BetRequestEnabled: boolean;
  StreamProviderIds: number[];
  HasOddBoost: boolean;
  CanPerformToPrice: boolean;
}

export interface EventListModel {
  Events: SportEvent[];
  success: boolean;
}

export interface EventsListResponse {
  data: EventListModel;
  success: boolean;
}

export enum EVENT_STATUS_TYPE {
  IN_PRICE = 1,
  NOT_IN_PRICE = 2,
  CANCELLED = 3,
  PARTIALLY_RESULTED = 4,
  FULL_RESULTED = 5,
  OPEN = 6,
}

export interface EventsListFilterModel {
  dateRange: DateRange;
  BetRequestEnabled?: LabelValueType;
  Sports?: LabelValueType[];
  Countries?: LabelValueType[];
  Tournaments?: number[];
  eventType?: LabelValueType;
  provider?: LabelValueType;
  uniqueFranchises?: LabelValueType[];
  EventSubType?: LabelValueType;
  skip?: number;
  take?: LabelValueType;
  currentPage?: number;
  TeamName?: string | null;
  OrderColumnName: string;
  OrderColumnDirection: number;
  Id: string | null;
  HasOddBoost?: LabelValueType;
}

export interface EventsListRequestBody {
  StartingAfter: string;
  StartingBefore: string;
  BetRequestEnabled?: boolean;
  Sports?: number[];
  Countries?: number[];
  Tournaments?: number[];
  EventType?: number;
  ProviderId?: string;
  UniqueFranchises?: number[];
  EventSubType?: number;
  Skip?: number;
  Take?: number;
  TeamName?: string;
  Id?: number;
  HasOddBoost?: boolean;
}

export interface EventComment {
  Id: number;
  ManagerId: number;
  EventId: number;
  CommentTranslations: {
    [key: number]: string;
  }
}

export interface TournamentComment {
  ID: number;
  LanguageID: number;
  LanguageName: string;
  Name: string;
  TournamentID: number;
}

export interface EventCommentsResponse {
  data: EventComment[];
  success: boolean;
}

export interface SimpleDataModel {
  Id: number;
  Name: string;
}

export interface EventOfTheDayTournamentResponse {
  data: SimpleDataModel[];
  success: boolean;
}

export enum EVENT_LIST_COLUMNS {
  ID = 'Id',
  START_DATE = 'StartDate',
  SPORTS = 'Sports',
  COUNTRIES = 'Countries',
  TOURNAMENTS = 'Tournaments',
  TEAM1NAME = 'Team1Name',
  TEAM2NAME = 'Team2Name',
  SCORE = 'Score',
  BET_COUNT = 'BetsCount',
  COMMENTS = 'Comment',
  STATUS_TYPE = 'StatusType',
  TURNOVER = 'Turnover',
  UNIQUE_FRANCHISE_NAME = 'UniqueFranchiseName',
  PROVIDER_NAME = 'ProviderName',
  CREATED = 'CreatedDate',
  ENDED = 'EndDate',
  MAX_AMOUNT_EVENT = 'MaxAmountEvent',
  MANAGER_NAME = 'ManagerName',
  MBL = 'Mbl',
  EVENT_TYPE = 'EventType',
  HAS_STREAM = 'HasStream',
  EVENTSUBTYPE = 'EventSubType',
  HASODDBOOST = 'HasOddBoost',
}

export enum EventType {
  H2H = 0,
  CUSTOM = 1,
  LIVE = 2,
}

export const eventTypeOptions: LabelValueType[] = [
  { label: 'H2H', value: EventType.H2H.toString() },
  { label: 'Custom', value: EventType.CUSTOM.toString() },
  { label: 'Live', value: EventType.LIVE.toString() },
];

export interface CreateEventFormModel {
  Sport: LabelValueType;
  Country: LabelValueType;
  Tournament: LabelValueType;
  HomeTeam: LabelValueType;
  AwayTeam: LabelValueType;
  DateStart: string;
  Brand?: LabelValueType | null;
  EventType: LabelValueType;
  ForceCreateDuplicate?: boolean;
}

export interface CreateEventRequest {
  SportId: number;
  CountryId: number;
  TournamentId: number;
  Team1Id: number;
  Team2Id: number;
  DateStart: string;
  EventType: number;
  FranchiseId?: string;
  ForceCreateDuplicate?: boolean;
}

export enum EVENT_LIST_PAGE_SEARCH_PARAMS {
  EVENT_ID = 'id',
  EVENT_START_DATE = 'date',
  PROVIDER_ID = 'providerId',
}
